import {
    IContato,
    IFiltroListarContatos,
} from "../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarContatosFiltroService(
    requestBody: IFiltroListarContatos
) {
    return Service(
        Axios.post<Array<IContato>>(
            `/automacao/audiencia/listarcontatosfiltro`,
            requestBody
        )
    );
}

export async function VincularContatosService(
    idAudiencia: number,
    idContatos: Array<number>
) {
    return Service(
        Axios.post(
            `automacao/audiencia/vincularcontatoaudiencia?idAudiencia=${idAudiencia}`,
            idContatos
        )
    );
}

export async function DesvincularContatosService(
    idAudiencia: number,
    idContatos: Array<number>
) {
    return Service(
        Axios.post(
            `automacao/audiencia/desvincularcontatoaudiencia?idAudiencia=${idAudiencia}`,
            idContatos
        )
    );
}

export async function ExportarPlanilhaContatoAudienciaService(
    ID_AUDIENCIA: number
) {
    return Service(
        Axios.post(
            `/automacao/audiencia/exportarplanilhacontatoaudiencia?ID_AUDIENCIA=${ID_AUDIENCIA}`,
            null,
            {
                responseType: "blob",
            }
        )
    );
}
export async function ImportarPlanilhaContatoAudienciaService(
    ID_AUDIENCIA: number,
    file: File
) {
    const form = new FormData();
    form.append("file", file, file.name);

    return Service(
        Axios.post(
            `/automacao/audiencia/importarplanilhacontatoaudiencia?ID_AUDIENCIA=${ID_AUDIENCIA}`,
            form
        )
    );
}
